import { memo } from "react";
import { Col, Row } from "antd";
import { CgCheckO } from "react-icons/cg";
import { MdOutlineRadioButtonUnchecked } from "react-icons/md";
import {
  InputField,
  SubmitButton,
  TextComponent,
  TimePickerInput,
} from "../../../../../components";
import { ClockIcon } from "../../../../../components/icons/Icons";
import Modal from "../../../../../components/modal/Modal";
import styles from "../editBusinessInfo.module.css";
import moment from "moment";

const days = [
  {
    id: 1,
    day: "Mon",
  },
  {
    id: 2,
    day: "Tue",
  },
  {
    id: 3,
    day: "Wed",
  },
  {
    id: 4,
    day: "Thu",
  },
  {
    id: 5,
    day: "Fri",
  },
  {
    id: 6,
    day: "Sat",
  },
  {
    id: 7,
    day: "Sun",
  },
];

const AvailablityModal = ({
  isAvailablityModalOpen,
  setIsAvailablityModalOpen,
  setStartTime,
  setEndTime,
  startTime,
  endTime,
  serveDay,
  onSelectDay,
}) => {
  return (
    <Modal
      isModalOpen={isAvailablityModalOpen}
      setIsModalOpen={setIsAvailablityModalOpen}
      closable={true}
      // pinkBg={true}
      wideModal={true}
      className={styles.modalContent}
    >
      <TextComponent text={"Set Availability"} textClass={styles.texthead} />
      {/* <InputField value={"Weekly"} disabled={true}/> */}
      <Row>
        <Col className={styles.sub_div}>
          <TextComponent text="Availability Time" textClass={styles.lable} />
          <Row justify={"space-around"}>
            <Col>
              <TimePickerInput
                label="Start Time"
                icon={<ClockIcon size={15} />}
                onChange={(time, timeString) => {
                  setStartTime({ timeString: timeString, time: time });
                }}
              />
            </Col>
            <Col>
              <TimePickerInput
                label="End Time"
                icon={<ClockIcon size={15} />}
                onChange={(time, timeString) => {
                  setEndTime({ timeString: timeString, time: time });
                }}
              />
            </Col>
          </Row>
          <div className={styles.mainTimeCont}>
            <div className={styles.timeDiv}>
              <TextComponent text="Start Time" textClass={styles.lable} />
              <input
                value={
                  startTime ? moment(startTime?.time?.$d).format("hh") : "00"
                }
                className={`${styles.timeInput} ${styles.hour}`}
                type="number"
                disabled
              />
              <input
                value={
                  startTime ? moment(startTime?.time?.$d).format("mm") : "00"
                }
                className={styles.timeInput}
                type="number"
                disabled
              />
              <TextComponent
                text={
                  startTime ? moment(startTime?.time?.$d).format("A") : "--"
                }
                textClass={styles.lable}
              />
            </div>
            <div className={styles.timeDiv}>
              <TextComponent text="End Time" textClass={styles.lable} />
              <input
                value={endTime ? moment(endTime?.time?.$d).format("hh") : "00"}
                className={`${styles.timeInput} ${styles.hour}`}
                type="number"
                disabled
              />
              <input
                value={endTime ? moment(endTime?.time?.$d).format("mm") : "00"}
                className={styles.timeInput}
                type="number"
                disabled
              />
              <TextComponent
                text={endTime ? moment(endTime?.time?.$d).format("A") : "--"}
                textClass={styles.lable}
              />
            </div>
          </div>
        </Col>

        <Col className={styles.sub_divx}>
          <TextComponent text="Set Days" textClass={styles.lable} />
          <Row>
            {days?.map((day, i) => (
              <Col
                key={day.id}
                xs={22}
                lg={10}
                className={`${
                  serveDay?.find((item) => item.day == day.day)
                    ? styles.activeCategory
                    : styles.categoryCont
                } ${styles.days}`}
                onClick={() => onSelectDay(day)}
              >
                <div className={styles.daysCont}>
                  {serveDay?.find((item) => item.day == day.day) ? (
                    <CgCheckO size={20} />
                  ) : (
                    <MdOutlineRadioButtonUnchecked size={20} />
                  )}
                  <TextComponent text={`${day?.day}`} />
                </div>
              </Col>
            ))}
          </Row>
        </Col>

        <SubmitButton
          title={"Save"}
          onClick={() => setIsAvailablityModalOpen(false)}
          btnClass={styles.button}
        />
      </Row>
    </Modal>
  );
};

export default AvailablityModal;
